export default __webpack_public_path__ + "static/media/categorias.afb7a223.svg";